import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/exchange/points-exchanges?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/exchange/points-exchanges/${id}`, { params });
}

export async function create(body) {
  return request(`/exchange/points-exchanges`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/exchange/points-exchanges/${id}`, {
    method: 'POST',
    body,
  });
}

